<ion-header>
  <ion-toolbar>
    <ion-button class="back" slot="end" fill="solid" (click)="cancel()">
      <ion-icon slot="start" name="close-circle-outline"></ion-icon>
      {{ 'General.Cancel' | translate }}
    </ion-button>
    <ion-title  class="modal-title">{{ 'Checkout.TwoForOneTitle' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
@if (items.length > 0) {
  <ion-content>
    <div style="margin-bottom: 60px;">
      <ion-grid>
        <!-- ROW FOR HEADING -->
        <ion-row>
          <ion-col style="display: flex;justify-content: center">
            <div style="margin: 5px; text-align: center;">
              <div style="font-size:15pt; font-weight: bold;">
                {{ 'Checkout.ChooseSecondItem' | translate }}
              </div>
            </div>
          </ion-col>
        </ion-row>
        <div class="horizontalDisplay">
          @for (item of items; track item) {
            <ion-row style="float:left;">
              <ion-card  [class.disable-item]="!item.isActive" style="height: 100%;" class="horizontal-card full-word-inline ion-activatable" (click)="onItemClick(item)">
                <ion-ripple-effect></ion-ripple-effect>
                <ion-col size="7"><b style="text-wrap: auto;">{{ item.itemName.translations[translationService.getLanguage()] }}  </b></ion-col>
                <ion-col size="5" style="padding-left:0px; padding-right: 0px;">
                  <ion-grid style="padding-left:0px; padding-right: 0px; height: 100%; justify-content: center;">
                    <ion-row style="height: 50%; justify-content: center;">
                      <span [class.disable-item]="!item.isActive">
                        {{ item.price | currency }}<br>
                        @if (!item.isActive) {
                          <span
                            style="color: #D35429; font-size: 10px; font-weight: normal;">({{'Confirmation.OutOfStockTitle' | translate}})
                          </span>
                        }
                      </span>
                    </ion-row>
                  </ion-grid>
                </ion-col>
              </ion-card>
            </ion-row>
          }
        </div>
      </ion-grid>
    </div>
  </ion-content>
}